import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logodark.jpg";
import {
	Compass,
	Logout,
	Moon,
	Notes,
	PhoneCall,
	Settings,
	Sun,
	Ticket,
	Users,
	X,
} from "tabler-icons-react";
import useDarkMode from "../utils/darkMode";
import { MenuContext } from "../context/menuContext";

function Sidenav() {
	const location = useLocation();
	const actvMenu = location.pathname.split("/")[1];
	const [activeItem, setActiveItem] = useState(actvMenu);
	const [colorTheme, setTheme] = useDarkMode();
	const { mobileMenu, dispatch } = useContext(MenuContext);

	const handleMenu = () => {
		dispatch({ type: "HIDE" });
	};

	useEffect(() => {
		if (actvMenu === "") {
			setActiveItem("home");
		} else {
			setActiveItem(actvMenu);
		}
	}, [actvMenu]);

	return (
		<div
			className={
				mobileMenu
					? "absolute w-3/4 bg-slate-50 dark:bg-darkbg md:bg-transparent h-screen md:flex flex-col md:w-1/5 md:h-screen border-r border-r-slate-100 dark:border-r-darkborder md:fixed md:top-0 md:left-0 z-50"
					: "hidden absolute md:flex flex-col md:w-1/4 lg:w-1/5 md:h-screen border-r border-r-slate-100 dark:border-r-darkborder md:fixed md:top-0 md:left-0"
			}>
			<div className="flex items-center space-x-4 justify-between px-1 py-2">
				<span className="flex items-center space-x-2">
					<img src={logo} className="h-7 w-7" alt="logo" />
					<h1 className="font-bold font-logo text-sm lg:text-lg">sheEQUIP</h1>
				</span>
				<span className="flex space-x-2 items-center">
					<span
						onClick={() => setTheme(colorTheme)}
						className="border border-slate-500 dark:border-darkborder rounded-md p-[.09rem] cursor-pointer hover:bg-slate-500 hover:text-white">
						{colorTheme === "dark" ? (
							<Moon size={15} fill="black" />
						) : (
							<Sun size={15} fill="black" />
						)}
					</span>
					<span className="font-code text-sm bg-slate-100 dark:bg-darkbg border dark:border-darkborder px-1 rounded-md">
						admin
					</span>
					{mobileMenu && (
						<span
							className="text-slate-500 dark:text-darktext"
							onClick={() => dispatch({ type: "HIDE" })}>
							<X size={20} />
						</span>
					)}
				</span>
			</div>
			<div className="border-t border-t-slate-100 dark:border-t-darkborder px-2 py-4 flex flex-col space-y-1">
				<Link
					onClick={() => {
						setActiveItem("home");
						handleMenu();
					}}
					className={
						activeItem === "home"
							? "flex items-center bg-sky-50 dark:bg-darkbtn dark:text-darkbtntext text-sky-400 text-sm px-3 py-2 w-full rounded-md"
							: "flex items-center hover:bg-slate-100 dark:hover:bg-darkbtnhover text-slate-500 dark:text-darkbtntext hover:text-black dark:hover:text-darkbtntxthv text-sm px-3 py-2 w-full rounded-md"
					}
					to="/">
					<Compass size={20} className="mr-3 dark:text-sky-400" />
					<span className="font-medium">Dashboard</span>
				</Link>
				<Link
					onClick={() => {
						setActiveItem("users");
						handleMenu();
					}}
					className={
						activeItem === "users"
							? "flex items-center bg-sky-50 dark:bg-darkbtn dark:text-darkbtntext text-sky-400 text-sm px-3 py-2 w-full rounded-md"
							: "flex items-center hover:bg-slate-100 dark:hover:bg-darkbtnhover text-slate-500 dark:text-darkbtntext hover:text-black dark:hover:text-darkbtntxthv text-sm px-3 py-2 w-full rounded-md"
					}
					to="/users">
					<Users size={20} className="mr-3 dark:text-sky-400" />
					<span className="font-medium">Users</span>
				</Link>
				<Link
					onClick={() => {
						setActiveItem("events");
						handleMenu();
					}}
					className={
						activeItem === "events"
							? "flex items-center bg-sky-50 dark:bg-darkbtn dark:text-darkbtntext text-sky-400 text-sm px-3 py-2 w-full rounded-md"
							: "flex items-center hover:bg-slate-100 dark:hover:bg-darkbtnhover text-slate-500 dark:text-darkbtntext hover:text-black dark:hover:text-darkbtntxthv text-sm px-3 py-2 w-full rounded-md"
					}
					to="/events">
					<Ticket size={20} className="mr-3 dark:text-sky-400" />
					<span className="font-medium">Events</span>
				</Link>
				<Link
					onClick={() => {
						setActiveItem("features");
						handleMenu();
					}}
					className={
						activeItem === "features"
							? "flex items-center bg-sky-50 dark:bg-darkbtn dark:text-darkbtntext text-sky-400 text-sm px-3 py-2 w-full rounded-md"
							: "flex items-center hover:bg-slate-100 dark:hover:bg-darkbtnhover text-slate-500 dark:text-darkbtntext hover:text-black dark:hover:text-darkbtntxthv text-sm px-3 py-2 w-full rounded-md"
					}
					to="/features">
					<Notes size={20} className="mr-3 dark:text-sky-400" />
					<span className="font-medium">Features</span>
				</Link>
				<Link
					onClick={() => {
						setActiveItem("cta");
						handleMenu();
					}}
					className={
						activeItem === "cta"
							? "flex items-center bg-sky-50 dark:bg-darkbtn dark:text-darkbtntext text-sky-400 text-sm px-3 py-2 w-full rounded-md"
							: "flex items-center hover:bg-slate-100 dark:hover:bg-darkbtnhover text-slate-500 dark:text-darkbtntext hover:text-black dark:hover:text-darkbtntxthv text-sm px-3 py-2 w-full rounded-md"
					}
					to="/cta">
					<PhoneCall size={20} className="mr-3 dark:text-sky-400" />
					<span className="font-medium">CTA</span>
				</Link>
				<div className="flex space-x-3 px-3 py-2">
					<span
						className="w-5 h-5 rounded-md bg-slate-900 dark:bg-slate-500 cursor-pointer"
						onClick={() => setTheme(colorTheme && "dark")}></span>
					<span
						className="w-5 h-5 rounded-md bg-white border border-slate-900 cursor-pointer"
						onClick={() => setTheme(colorTheme && "light")}></span>
				</div>
			</div>

			<div className="border-t border-t-slate-100 dark:border-t-darkborder flex flex-col py-4 px-2">
				<Link
					onClick={() => {
						setActiveItem("settings");
						handleMenu();
					}}
					className={
						activeItem === "settings"
							? "flex items-center bg-sky-50 dark:bg-darkbtn dark:text-darkbtntext text-sky-400 text-sm px-3 py-2 w-full rounded-md"
							: "flex items-center hover:bg-slate-100 dark:hover:bg-darkbtnhover text-slate-500 dark:text-darkbtntext hover:text-black dark:hover:text-darkbtntxthv text-sm px-3 py-2 w-full rounded-md"
					}
					to="/settings">
					<Settings size={20} className="mr-3 dark:text-sky-400" />
					<span className="font-medium">Settings</span>
				</Link>
				<Link
					onClick={() => {
						setActiveItem("logout");
						handleMenu();
					}}
					className={
						activeItem === "logout"
							? "flex items-center bg-sky-50 dark:bg-darkbtn dark:text-darkbtntext text-sky-400 text-sm px-3 py-2 w-full rounded-md"
							: "flex items-center hover:bg-slate-100 dark:hover:bg-darkbtnhover text-slate-500 dark:text-darkbtntext hover:text-black dark:hover:text-darkbtntxthv text-sm px-3 py-2 w-full rounded-md"
					}
					to="/">
					<Logout size={20} className="mr-3 dark:text-sky-400" />
					<span className="font-medium">Logout</span>
				</Link>
			</div>
		</div>
	);
}

export default Sidenav;
